export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12129.7220d8bd.jpg";